import Loader from "atoms/loaders/loader";
import PublicationCodeGroupRecord from "models/view-models/publication-code-group-record";
import React from "react";
import { useLocalization } from "utilities/hooks/use-localization";
import PublicationRecord from "models/view-models/publication-record";
import PublicationGroup from "organisms/publication-lists/publication-group";
import UserPublicationPinRecord from "models/view-models/user-publication-pin-record";

export interface PublicationListProps {
    pins?: UserPublicationPinRecord[];
    onChangePins: (pins: UserPublicationPinRecord[]) => void;
    observerRef?: (node: any) => void;
    publicationGroups: PublicationCodeGroupRecord[];
    loading: boolean;
    onPublicationClick: (publication: PublicationRecord) => void;
}

const PublicationList: React.FunctionComponent<PublicationListProps> = (
    props
) => {
    const {
        observerRef,
        publicationGroups,
        loading,
        pins,
        onChangePins,
        onPublicationClick,
    } = props;

    const { t } = useLocalization();

    const loadingText = t("loadingItem", { item: t("publication") });

    return (
        <>
            {publicationGroups.map((publicationGroup) => {
                return (
                    <PublicationGroup
                        key={publicationGroup.code}
                        publicationGroup={publicationGroup}
                        pins={pins}
                        onChangePins={onChangePins}
                        onPublicationClick={onPublicationClick}
                    />
                );
            })}
            <div ref={observerRef} style={{ height: "20px" }}></div>
            {loading && <Loader accessibleText={loadingText} />}
        </>
    );
};

export default PublicationList;
